<template>

  <div class="row">
    <busy-indicator ref="main-busy-indicator"></busy-indicator>
    <div class="col-md-9">
      <text-editor ref="text-editor" @onTagSelected="regenerateHintControl" @onSpanDeselected="spanDeselected"></text-editor>
    </div>
    <div class="col-md-3">
      <div class="box">
        <!-- /.box-header -->
        <div class="box-body">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active"><a data-toggle="tab" href="#hints">Hints</a></li>
              <li>
                <a data-toggle="tab" href="#synonyms">
                  <i v-bind:style="{ color: this.synonymsAvailable ? '#f39c12' : 'lightgray' }" class="fas fa-lightbulb"></i>
                  Synonyms
                </a>
              </li>
              <li><a data-toggle="tab" href="#examples">
                <i v-bind:style="{ color: this.exampleSentancesAvailable ? '#f39c12' : 'lightgray' }" class="fas fa-lightbulb"></i>
                Examples
                </a></li>
            </ul>

            <div class="tab-content">
              <div id="hints" class="tab-pane fade in active">
                <tag-tip ref="tag-tip" style="margin-top:10px" @onHintSelected="replaceTextWithHint" @loaded="tagTipLoaded"></tag-tip>
              </div>
              <div id="synonyms" class="tab-pane fade">
                <synonyms-widget ref="synonyms-widget" style="margin-top:10px" @onHintSelected="replaceTextWithHint" @loaded="tagTipLoaded" @markSynonymWords="markSynonymWords"></synonyms-widget>
              </div>
              <div id="examples" class="tab-pane fade">
                <example-phrases-widget ref="example-phrases-widget" @markWordsWithExampleSentances="markSynonymWords"></example-phrases-widget>
              </div>
            </div>
          </div>

          

          
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->

      
    </div>
  </div>
</template>

<script>
import TextEditor from "./TextEditor";
import TagTip from "./TagTip";
import SynonymsWidget from "./SynonymsWidget";
import ExamplePhrasesWidget from "./ExamplePhrasesWidget";
import BusyIndicator from "./BusyIndicator";
const machina = require('machina');
import StoryProcessor from '../js/storyProcessor';

export default {
  name: "TextEditorFacade",
  provide: function(){
    return {
      storyProcessor: (new StoryProcessor)
    }
  },
  data: function() {
    return {
      states :undefined,
      loadOperations: [],
      selectedTag: undefined,
      synonymsAvailable: false,
      exampleSentancesAvailable: false
    };
  },
  components: {
    "text-editor": TextEditor,
    "tag-tip": TagTip,
    "busy-indicator": BusyIndicator,
    "synonyms-widget": SynonymsWidget,
    "example-phrases-widget": ExamplePhrasesWidget
  },
  created: function(){
    $(window).resize(function(a,b,c){
      console.log('resize');
      console.log(a);
      console.log(b);
      console.log(c);
    });
  },
  methods: {
    replaceTextWithHint: function(event){
      $(this.selectedTag).html($(event.target).html().trim());

      var textFromDiv = $(this.$refs['text-editor'].$refs['editor-text-area-div'])[0].innerText;

      this.$refs['text-editor'].editorData = textFromDiv;

      $(this.selectedTag).removeClass('span-underline-red');
      $(this.selectedTag).off();
    },

    regenerateHintControl: function($tagElement){
      this.selectedTag = $tagElement;

      this.spanDeselected();

      if($tagElement.hasClass('span-underline-red')){
        this.$refs['tag-tip'].getHints($tagElement.html());
      }
      else if($tagElement.hasClass('synonym')){
        var synonyms = this.$refs['synonyms-widget'].getSynonyms($tagElement.html());

        if(synonyms.length > 0){
          this.synonymsAvailable = true;
        }

        var exampleSentances = this.$refs['example-phrases-widget'].getExampleSentances($tagElement.html());

        if(exampleSentances.length > 0){
          this.exampleSentancesAvailable = true;
        }
      }
    },

    tagTipLoaded: function(){
      this.$refs['text-editor'].textAreaOnKeyUp();
    },

    spanDeselected: function() {
      this.synonymsAvailable = false;
      this.$refs['synonyms-widget'].clearData();

      this.exampleSentancesAvailable = false;
      this.$refs['example-phrases-widget'].clearData();
    },

    markSynonymWords: function(e) {
      this.$refs['text-editor'].switchSynonymsMarking(e.target.checked);
    }
  },
  mounted: function(){
    var that = this;

    that.states = new machina.Fsm({
      initialState: "Loaded",

      states: {
        Loading: {
          _onEnter: function() {
            that.$refs['main-busy-indicator'].showSpinner();
          },

          _onExit: function() {
          }
        },

        Loaded: {
          _onEnter: function() {
            that.$refs['main-busy-indicator'].hideAll();
          },

          _onExit: function() {
          }
        },

        LoadError: {
          _onEnter: function() {
            that.$refs['main-busy-indicator'].showError();
          },

          _onExit: function() {
          }
        }
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TextEditorFacade.vue